export default __webpack_public_path__ + "static/media/15.99f72c6b.jpg";